// Get a demo A/B test (CPL-27408). Rails picks the page design and keeps it in
// a cookie (see PagesController#book_a_demo); PostHog only measures it, through
// the experiment on this flag. Variant "a" is the flag's control, "b" its test.
const FLAG_KEY = 'get-demo-redesign'
const FLAG_VARIANTS = { a: 'control', b: 'test' }

// PostHog comes from GTM, so it may load well after the page.
const POSTHOG_WAIT_MS = 15000
const POSTHOG_POLL_MS = 250

const section = () => document.querySelector('[data-demo-variant]')

// The Get a demo page design the visitor sees.
export const demoVariant = () => section()?.dataset.demoVariant

// The design of a visitor who is in the test, for tagging their lead. Visitors
// who forced a design with ?variant= (QA) aren't in it and get none.
export const experimentVariant = () =>
  section()?.hasAttribute('data-demo-experiment') ? demoVariant() : undefined

const whenPosthogReady = callback => {
  const startedAt = Date.now()
  const poll = () => {
    if (typeof window.posthog?.capture === 'function') {
      callback(window.posthog)
    } else if (Date.now() - startedAt < POSTHOG_WAIT_MS) {
      setTimeout(poll, POSTHOG_POLL_MS)
    }
  }
  poll()
}

// Reports the visitor's design as the exposure event the experiment counts.
// PostHog resolves it per experiment ($experiment_exposure here), and also
// reads $experiment_exposure for older ones on $feature_flag_called. Visitors
// who forced a design with ?variant= aren't in the test and send nothing.
export const trackExposure = () => {
  const response = FLAG_VARIANTS[experimentVariant()]
  if (!response) return

  whenPosthogReady(posthog => {
    posthog.capture('$experiment_exposure', {
      $feature_flag: FLAG_KEY,
      $feature_flag_response: response,
      [`$feature/${FLAG_KEY}`]: response
    })
  })
}
